import * as _ from 'underscore';
import * as Globalize from '@mapp/globalize';
import { StudioNotification } from './studioNotification';
import { EditObject } from './editObject';
import {
	IKeyValue,
	IOption,
	IKeyBinding,
	IKeyBindingFn,
	IRelativeTime,
	ITryGetResult
} from '../interfaces';
import { KeyCode, PropertyType, ByteFormat } from '../enums';
import { ID, ByteFormatLabel } from '../const';
import { Localization } from 'mappMvc/compile';

export class StudioNotificationFactory {
	static new(): StudioNotification {
		return new StudioNotification();
	}
}

const RelativeTimeValues: IRelativeTime[] = [
	{ value: 1, unit: 'second' }, //start
	{ value: 60, unit: 'minute' }, //60
	{ value: 3600, unit: 'hour' }, //60*60
	{ value: 86400, unit: 'day' }, //60*60*24
	{ value: 604800, unit: 'week' }, //60*60*24*7
	{ value: 2419200, unit: 'month' }, //60*60*24*7*4
	{ value: 29030400, unit: 'year' } //60*60*24*7*4*12
];

export class Util {
	static keyCodeDictionary: {
		[key: string]: IKeyBindingFn[];
	} = {};
	static keyBindingFnCache: {
		[key: string]: (e: JQueryKeyEventObject) => void;
	} = {};
	static bindKeys(keyBindings: IKeyBinding[]) {
		keyBindings.forEach(keyBinding =>
			this.bindKey(keyBinding.keyCode, keyBinding.fn, keyBinding.thisArg)
		);
	}
	static unbindKeys(keyBindings: IKeyBinding[]) {
		keyBindings.forEach(keyBinding => this.unbindKey(keyBinding.keyCode, keyBinding.fn));
	}
	static _studioNotification: StudioNotification = StudioNotificationFactory.new();
	static get StudioNotification(): StudioNotification {
		return this._studioNotification;
	}
	static bindKey(keyCode: KeyCode, fn: Function, thisArg?: any) {
		var keyCodeID = KeyCode[keyCode],
			keyBindingFn = this.keyBindingFnCache[keyCodeID];
		if (!keyBindingFn) {
			//start listening on keyCode
			this.keyCodeDictionary[keyCodeID] = [];
			this.keyBindingFnCache[keyCodeID] = (e: JQueryKeyEventObject) => {
				//&& e.target.nodeName != 'INPUT'
				//&& e.target.nodeName != 'TEXTAREA'
				if (e.keyCode == keyCode) {
					this.notifyKeyBindings(keyCode);
				}
			};
			// TODO: Revise
			// $(document).keyup(this.keyBindingFnCache[keyCodeID]);
			$(document).keyup(<any>this.keyBindingFnCache[keyCodeID]);
		}
		this.keyCodeDictionary[keyCodeID].push(<IKeyBindingFn>{
			fn: fn,
			thisArg: thisArg
		});
	}
	static unbindAllKeys() {
		if (this.keyCodeDictionary && _.keys(this.keyCodeDictionary).length > 0) {
			_.keys(this.keyCodeDictionary).forEach(keyCode => {
				if (this.keyCodeDictionary[keyCode] && this.keyCodeDictionary[keyCode].length > 0) {
					this.keyCodeDictionary[keyCode].forEach(keyBindingFn => {
						this.unbindKey(KeyCode[keyCode], keyBindingFn.fn);
					});
				}
			});
		}
	}
	static unbindKey(keyCode: KeyCode, fn: Function) {
		var keyCodeID = KeyCode[keyCode],
			keyCodeDictionaryEntries = this.keyCodeDictionary[keyCodeID];
		var keyBindingFn = _.find(keyCodeDictionaryEntries, keyCodeDictionaryEntry => {
			return keyCodeDictionaryEntry.fn === fn;
		});
		if (keyBindingFn) {
			Util.remove(keyCodeDictionaryEntries, keyBindingFn);
		}
		if (keyCodeDictionaryEntries && keyCodeDictionaryEntries.length <= 0) {
			//stop listening on keyCode
			// TODO: Revise
			// $(document).unbind('keyup', this.keyBindingFnCache[keyCodeID]);
			$(document).unbind('keyup', <any>this.keyBindingFnCache[keyCodeID]);
			delete this.keyBindingFnCache[keyCodeID];
		}
	}
	static notifyKeyBindings(keyCode: KeyCode) {
		this.keyCodeDictionary[KeyCode[keyCode]].forEach(function(keyBindingFn) {
			keyBindingFn.fn.call(keyBindingFn.thisArg);
		});
	}
	static contains<T>(array: T[], element: T): boolean {
		let index: number = array.indexOf(element);
		if (index >= 0) {
			return true;
		}
		return false;
	}
	static containsRemove<T>(array: T[], element: T): boolean {
		var index: number = array.indexOf(element);
		if (index >= 0) {
			array.splice(index, 1);
			return true;
		}
		return false;
	}
	static remove<T>(array: T[], element: T): T[] {
		var index: number = array.indexOf(element);
		if (index >= 0) {
			array.splice(index, 1);
		}
		return array;
	}
	static pushIfNotExists<T>(array: T[], element: T): T[] {
		var index: number = array.indexOf(element);
		if (index === -1) {
			array.push(element);
		}
		return array;
	}
	static getQueryParams(query: string): any {
		return _.object(
			_.compact(
				_.map(query.slice(1).split('&'), function(item) {
					if (item) return item.split('=');
				})
			)
		);
	}
	static splitRoute(route: string): string[] {
		return route == null || route == undefined || _.isEmpty(route) ? null : route.trim().split('/');
	}
	static removeRules<T>(observable: KnockoutObservable<T>, rules: string[]) {
		var koRules: KnockoutValidationRule[] = observable.rules().filter(rule => {
			return _.contains(rules, rule.rule);
		});
		koRules.forEach(koRule => observable.rules.remove(koRule));
	}
	static cloneRules<T>(source: KnockoutObservable<T>, target: KnockoutObservable<T>): void {
		if (source.rules && ko.isObservable(source.rules)) {
			source.rules().forEach(rule => {
				ko.validation.addRule(target, rule);
			});
		}
	}
	static subscribe(
		observables: KnockoutObservable<any>[],
		subscribtion: (newValue: any) => void,
		delay?: number
	) {
		observables.forEach(observable => {
			observable.subscribe(subscribtion);
			if (delay) {
				observable.extend({
					rateLimit: { method: 'notifyWhenChangesStop', timeout: delay }
				});
			}
		});
	}
	static isEmpty(observables: KnockoutObservable<any>[]): boolean {
		return !_.isEmpty(
			_.find(observables, observable => {
				return _.isEmpty(observable());
			})
		);
	}
	static getNextEnum<E>(current: number, e: any): E {
		var keys = Object.keys(e),
			length = keys.length / 2,
			currentIndex = keys.indexOf(current.toString()) + length,
			nextIndex = currentIndex == keys.length - 1 ? length : currentIndex + 1;
		return <E>e[keys[nextIndex]];
	}

	static enumToOptions<E>(e: any): IOption<E>[] {
		var keys = Object.keys(e),
			length = keys.length / 2,
			options = <IOption<E>[]>[];
		for (let i = 0; i < length; i++) {
			options.push({
				id: <E>e[e[keys[i]]],
				label: e[keys[i]]
			});
		}
		return options;
	}

	static enumToStringArray(e: any, toLowerCase: boolean = true): string[] {
		let enumStringArray: string[] = [];
		let keys = Object.keys(e);
		let length = keys.length / 2; //ensure typescript is creating the first half of enum with int keys

		let getString = (index: number) =>
			toLowerCase ? e[keys[index]].toString().toLowerCase() : e[keys[index]].toString();

		for (let i = 0; i < length; i++) {
			enumStringArray.push(getString(i));
		}
		return enumStringArray;
	}

	static getEnumKey<E>(e: any, label: string, isLowerCase: boolean = true): E {
		for (let key in e) {
			let keyString = isLowerCase ? key.toString().toLowerCase() : key.toString();
			if (keyString == label) {
				return e[key];
			}
		}
	}

	static toKeyValue<E>(key: string, values: any[]): IKeyValue<E>[] {
		var result = new Array<any>();
		for (let i = 0; i < values.length; i++) {
			result.push({ [key]: <E>values[i] });
		}
		return result;
	}
	static reverseClonedArray<T>(array: KnockoutObservableArray<T> | T[]): T[] {
		var clonedArray = this.cloneArray<T>(array);
		return clonedArray.reverse();
	}
	static cloneArray<T>(array: KnockoutObservableArray<T> | T[]): T[] {
		return array.slice(0);
	}
	static cloneObservableArray<T>(
		observableArray: KnockoutObservableArray<T>
	): KnockoutObservableArray<T> {
		var clonedArray = this.cloneArray<T>(observableArray);
		return ko.observableArray(clonedArray);
	}
	static setValue(value: any, ...observables: KnockoutObservable<any>[]) {
		observables.forEach(obs => {
			obs(value);
		});
	}
	static getProperty(model: any, key: string): any {
		let properties = model;
		if (model instanceof EditObject) {
			properties = model.Properties;
		}
		if (key.indexOf('.') > 0) {
			key.split('.').forEach(subKey => {
				properties = properties[subKey];
			});
			return properties;
		}
		return properties[key];
	}
	static getValidationMessage(model: any, key: string, debug: boolean = false): string {
		if (debug) {
			debugger;
		}
		let validationMessageKey: string = this.getProperty(model, key);
		return Localization.Validation[validationMessageKey];
	}
	static getEnumProperty(model: any, key: string, e: any): any {
		return e[Util.getProperty(model, key)].toString();
	}
	static getNextSequenceID(preFix: string, sequencList: string[], i: number = 1): string {
		let nextSequenceID = preFix.concat(i.toString());
		if (_.contains(sequencList, nextSequenceID)) {
			return this.getNextSequenceID(preFix, sequencList, ++i);
		}
		sequencList.push(nextSequenceID);
		return nextSequenceID;
	}
	static hasValue(...obsList: any[]) {
		return obsList.every(obs => {
			let unwrappedValue = ko.unwrap(obs);
			return (
				!_.isUndefined(unwrappedValue) &&
				!_.isNull(unwrappedValue) &&
				!((_.isString(unwrappedValue) || _.isArray(unwrappedValue)) && _.isEmpty(ko.unwrap(obs)))
			);
		});
	}
	static loadings: string[] = [];
    
	static loading(state: boolean = true, elementSelector: string = '.right-content') {
		let loading = $('#' + ID.Loading);
		if (!state) {
			Util.remove(this.loadings, elementSelector);
			if (this.loadings.length == 0) {
				loading.hide();
			} else {
				this.loading(true, this.loadings[this.loadings.length - 1]);
			}
			return;
        }

        let element = $(elementSelector);

        if (element) {

            let menu = document.querySelector('.content-section nav.left-menu');
			Util.pushIfNotExists(this.loadings, elementSelector);
            
            if (menu)
                loading.css({ left: menu.clientWidth + 'px' });

            loading.show();

		} else {
			throw new Error(`Loading animation: element not found [${elementSelector}]`);
		}
	}
	static loadingOff() {
		this.loadings = [];
		this.loading(false);
	}
	static convert(value: any, propertyType: PropertyType): any {
		if (value === null || value === undefined) return value;
		value = _.isString(value) ? (<string>value).trim() : value;
		switch (propertyType) {
			case PropertyType.BOOLEAN:
				return value === 'true' || value === '1' || value === 1 ? true : false;
			case PropertyType.NUMBER:
				return parseInt(value);
			default:
				return value;
		}
	}

	static format(format: string, ...values: string[]): string {
		var text = format;
		for (var i = 0; i < values.length; i++) {
			text = text.replace('{' + i.toString() + '}', values[i]);
		}
		return text;
	}

	static defaults(target: any, defaults: any, obj: any) {
		for (var i in defaults) {
			target[i] =
				typeof defaults[i] == 'object' &&
				defaults[i] !== null &&
				obj != null &&
				obj[i] !== null &&
				obj[i] !== undefined
					? this.defaults({}, defaults[i], obj[i])
					: obj != null && obj[i] !== undefined && obj[i] !== null
					? obj[i]
					: defaults[i];
		}

		return target;
	}

	static forceBiDi(text: string, isRtl: boolean = false): string {
		if (isRtl) {
			return '\u200F' + text + '\u200F';
		} else {
			return '\u200E' + text + '\u200E';
		}
	}

	static relativeTime(seconds: number): IRelativeTime {
		let absSeconds = Math.abs(seconds);
		let length = RelativeTimeValues.length;
		let index = 0;

		while (index + 1 < length && absSeconds >= RelativeTimeValues[index + 1].value) {
			index++;
		}

		return <IRelativeTime>{
			unit: RelativeTimeValues[index].unit,
			value: Math.floor(seconds / RelativeTimeValues[index].value)
		};
	}

	static tryGetDate(date: string | Date): ITryGetResult<Date> {
		let out: ITryGetResult<Date> = {
			isValid: false,
			result: null
		};

		if (date == undefined || date == null) {
			return out;
		}

		let parsedDate: Date;
		if (_.isString(date)) {
			parsedDate = new Date(date);
		} else {
			parsedDate = new Date(date.getTime());
		}

		if (parsedDate.getTime() !== undefined) {
			out.result = parsedDate;
			out.isValid = true;
		}

		return out;
	}

	static stringToIndex(str: string, max: number) {
		let index = 0;
		let pendulum = 1;
		if (!str.length) return index;

		for (let i = 0, length = str.length, n, nextIndex; i < length; ++i) {
			n = str.charCodeAt(i);
			nextIndex = index + n * pendulum;
			if (nextIndex > max || nextIndex < 0) {
				pendulum *= -1;
			}
			index = index + n * pendulum;
		}

		return index > max ? max : index < 0 ? 0 : index;
	}

	static isMilitaryTime(shortTimeFormat?: string): boolean {
		let _shortTimeFormat =
			shortTimeFormat || Globalize.cldr.main('dates/calendars/gregorian/timeFormats/short');

		return (
			!_.isEmpty(_shortTimeFormat) &&
			_shortTimeFormat.charAt(_shortTimeFormat.length - 1).toLowerCase() !== 'a'
		);
	}

	static getShortDateTimeSkeleton(): string {
		if (this.isMilitaryTime()) {
			return 'yMdHm';
		} else {
			return 'yMdhm';
		}
	}

	static toByteString(
		bytes: number,
		toByteFormat: ByteFormat = ByteFormat.KILOBYTE,
		upperCase: boolean = true
	): string {
		let byteFormatLabel = ByteFormatLabel[toByteFormat];
		let factor: number = toByteFormat;
		let outputBytes = bytes;
		if (factor > 0) {
			outputBytes = bytes / (1024 * factor);
		}
		if (upperCase) {
			byteFormatLabel = byteFormatLabel.toUpperCase();
		}

		return Util.format(
			Localization.Validation.fileSize,
			Util.format('{0} {1}', Globalize.formatNumber(outputBytes), byteFormatLabel)
		);
	}
}
